import { Article, LayoutStyle } from "../../types";
import { WideNewsCard } from "./components/WideNewsCard";
import { TallNewsCard } from "./components/TallNewsCard";
import { CSSProperties } from "react";

export function NewsCard({
  content,
  size,
  ...props
}: {
  content: Article;
  size: LayoutStyle["size"];
  titleFontSize?: CSSProperties["fontSize"];
}) {
  const cardMap: Record<string, JSX.Element> = {
    xl: <WideNewsCard {...content} {...props} size={size} />,
    l: <TallNewsCard {...content} {...props} size={size} />,
    m: <TallNewsCard {...content} {...props} size={size} />,
    s: <WideNewsCard {...content} {...props} size={size} />,
    xs: <WideNewsCard {...content} {...props} size={size} />,
  };

  return cardMap[size];
}
